import { Injectable } from '@angular/core';

import { Occ, Product, ProductReferenceNormalizer } from '@spartacus/core';

@Injectable({
  providedIn: 'root'
})
export class CustomProductReferenceNormalizer extends ProductReferenceNormalizer {
  convert(source: Occ.Product, target?: Product): Product {
    if (target === undefined) {
      target = { ...(source as any) } as Product;
    }

    if (!!source && source.productReferences) {
      target.productReferences = super.normalize(source.productReferences);
    }
    return target;
  }
}
